import { render } from "./Billabletypes.vue?vue&type=template&id=10d956e9&scoped=true"
import script from "./Billabletypes.vue?vue&type=script&lang=js"
export * from "./Billabletypes.vue?vue&type=script&lang=js"

import "./Billabletypes.vue?vue&type=style&index=0&id=10d956e9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10d956e9"]])

export default __exports__